const guiColors = {
    'looks-secondary': 'rgb(53, 173, 53)',
    'looks-transparent': 'hsla(112, 100.00%, 65.10%, 0.35)',
    'looks-light-transparent': 'hsla(115, 100.00%, 65.10%, 0.15)',
    'looks-secondary-dark': 'rgb(84, 204, 51)'
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
